module.exports = __webpack_public_path__ + "img/KSC03461.8abcbdcb.jpg";